import { BadgeColor, BadgeSize, BadgeType } from "../Badge";
import { BadgeGroupColor, BadgeGroupSize, BadgeGroupType } from "./BadgeGroup";

export function mapBadgeGroupSizeToBadgeGroup(v: BadgeGroupSize): BadgeSize {
  switch (v) {
    case "md":
      return "sm";
    case "lg":
      return "md";
  }
}

export function mapBadgeGroupColorToBadgeColor(v: BadgeGroupColor): BadgeColor {
  return v;
}

export function mapBadgeGroupTypeToBadgeType(v: BadgeGroupType): BadgeType {
  switch (v) {
    case "modern":
      return "badgeModern";
    case "outline":
      return "pillOutline";
    case "light":
      return "pillColor";
  }
}